/**
 *
 * PluginIcon
 *
 */

import React from 'react';
import { Hashtag } from '@strapi/icons';
const PluginIcon = () => /*#__PURE__*/React.createElement(Hashtag, null);
export default PluginIcon;